import {ApplicationStatus, EvaluationOutcome} from "./application"
import {ProductApplicationStatus} from "./productApplication"

type Status = ApplicationStatus | ProductApplicationStatus

const approvableStatuses: Status[] = [
	ApplicationStatus.AwaitingDocuments,
	ApplicationStatus.AwaitingInformation,
	ApplicationStatus.PendingReview,
	ApplicationStatus.Denied,
]

const deniableStatuses: Status[] = [
	ApplicationStatus.AwaitingDocuments,
	ApplicationStatus.AwaitingInformation,
	ApplicationStatus.PendingReview,
]

const cancelableStatuses: Status[] = [
	ApplicationStatus.AwaitingDocuments,
	ApplicationStatus.AwaitingInformation,
	ApplicationStatus.PendingReview,
]

export function getApplicationActions(
	status: ApplicationStatus,
	evaluationOutcome?: EvaluationOutcome,
	archived = false
) {
	return getActions(status, archived, evaluationOutcome)
}

export function getProductApplicationActions(status: ProductApplicationStatus, archived = false) {
	return getActions(status, archived)
}

function getActions(status: Status, archived: boolean, evaluationOutcome?: EvaluationOutcome) {
	const isPendingApplicationCancelable =
		status === ApplicationStatus.Pending && evaluationOutcome === EvaluationOutcome.Pending

	return {
		canApprove: !archived && approvableStatuses.includes(status),
		canDeny: !archived && deniableStatuses.includes(status),
		canCancel: !archived && (cancelableStatuses.includes(status) || isPendingApplicationCancelable),
	}
}
